const RUVINE_CART_URGENCY_DURATION = 10 * 60 * 1000;
const ruvineCartUrgencyDeadline = Date.now() + RUVINE_CART_URGENCY_DURATION;

function updateRuvineCartUrgency() {
  const remaining = Math.max(0, ruvineCartUrgencyDeadline - Date.now());
  const totalSeconds = Math.ceil(remaining / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const displayTime = `${String(minutes).padStart(2, '0')}m${String(seconds).padStart(2, '0')}s`;

  document.querySelectorAll('[data-ruvine-cart-urgency]').forEach((timer) => {
    const activeMessage = timer.querySelector('[data-ruvine-urgency-active]');
    const expiredMessage = timer.querySelector('[data-ruvine-urgency-expired]');
    const time = timer.querySelector('[data-ruvine-urgency-time]');
    if (remaining > 0) {
      if (time) time.textContent = displayTime;
      activeMessage?.removeAttribute('hidden');
      expiredMessage?.setAttribute('hidden', '');
      return;
    }
    activeMessage?.setAttribute('hidden', '');
    expiredMessage?.removeAttribute('hidden');
  });
}

updateRuvineCartUrgency();
window.setInterval(updateRuvineCartUrgency, 1000);
